// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_15K_b5rThVG-lvAj35nAlF"};